module.exports = __webpack_public_path__ + "img/ES1472.4c20caa7.png";